import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Footer } from "../../../layout/footer/footer.component";
import { NormalNavbar } from "../../../layout/normal-navbar/normal-navbar";
import { SeoService } from '../../../core/services/seo/seo.service';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, RouterModule, NormalNavbar, Footer],
  templateUrl: './contact.html',
  styleUrl: './contact.scss'
})
export class ContactComponent implements OnInit {

  constructor(private seoService: SeoService) { }

  ngOnInit(): void {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 0);
    }
    this.seoService.setSeo({
      title: 'Contact Us',
      description: 'Contact the SceneTale Cinema team. Submit inquiries, report bugs, ask legal questions, or reach out regarding advertising.',
      url: '/contact',
      type: 'website'
    });
  }
}
